import Repository from './Repository'

export default {
    getVideos() {
        return Repository.get('library/videos')
    }
}